// Vendor Libs
import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {get} from 'lodash';

// Redux Actions
import {
    mappingCancelMapping,
    mappingCompleteMapping,
    mappingCreateCustomShell,
    mappingGoToNextMediaItem,
    mappingReset,
    mappingResetContentType,
    mappingSetBulkMapping,
    mappingSetData,
    mappingSetDataFromShell,
    mappingSetMassMapping,
    mappingSetShowMessage,
    mappingSetShowRememberMapping,
    mappingSkipMassMapping,
} from '../actions/mapping-actions';
import {setFieldValue, setFieldValues} from '../actions/form-data-actions';

import {massActionSetChildFormData, massActionSubmit} from '../actions/mass-action-data-actions';

// Config
import echostarContentTypeMap from '../bootstrap-data/echostar-content-type-map';

// Contexts
import {TabContext} from '../contexts/tab-context';

const mappingTabNames = ['BESTMATCHES', 'MOVIESANDPROGRAMSMAPPING', 'CREATESHELL'];

class Mapping extends Component {
    componentWillUnmount() {
        const {mappingReset, resetOnUnmount} = this.props;

        if (resetOnUnmount) {
            mappingReset(true);
        }
    }

    getCurrentContentType = () => {
        const {mappingData} = this.props;

        return get(mappingData, 'episode.echostarContentType') || get(mappingData, 'franchise.echostarContentType');
    };

    cancelMapping = () => {
        const {mappingCancelMapping} = this.props;
        const {isTabActive, selectFirstTab} = this.context;

        mappingCancelMapping();

        if (isTabActive('CREATESHELL')) {
            selectFirstTab(mappingTabNames);
        }
    };

    mapItem = () => {
        const {mappingCompleteMapping} = this.props;

        mappingCompleteMapping();
    };

    isFetched = (props = this.props) => props.fetched;

    isRecordShow = (props = this.props) => get(props.mappingData, 'franchise.echostarContentType') === 'SRM';

    scrollIntoView = (component) => {
        const {showRememberMapping} = this.props;

        if (component && !showRememberMapping) {
            component.scrollIntoView();
        }
    };

    shouldFilterByEpisode = () => {
        const {mappingData} = this.props;

        return (
            !this.isFetched() &&
            (get(mappingData, 'franchise.seriesId') || get(mappingData, 'franchise.gnSeriesId')) &&
            get(echostarContentTypeMap, `${this.getCurrentContentType()}.filterForEpisodes`)
        );
    };

    render() {
        const {
            activeTab,
            bulkMapping,
            bulkMappingType,
            children,
            error,
            fetched,
            fetching,
            formData,
            lastMassItem,
            mappingCancelMapping,
            mappingCompleteMapping,
            mappingCreateCustomShell,
            mappingData,
            mappingGoToNextMediaItem,
            mappingReset,
            mappingResetContentType,
            mappingSetBulkMapping,
            mappingSetData,
            mappingSetDataFromShell,
            mappingSetMassMapping,
            mappingSetShowMessage,
            mappingSetShowRememberMapping,
            mappingSkipMassMapping,
            massActionData,
            massActionSetChildFormData,
            massActionSubmit,
            massMapping,
            massShell,
            massShellActive,
            mediaItemData,
            mediaItemDetailFetching,
            mediaItems,
            mediaItemsFilter,
            rememberMappingData,
            response,
            routerParams,
            setFieldValue,
            setFieldValues,
            shellContentType,
            showMessage,
            showRememberMapping,
            unmappedMediaItems,
            unmappedMediaItemsFilter,
            username,
            validShell,
        } = this.props;
        const {isTabActive, selectFirstTab, selectTab} = this.context;
        const childrenProps = {
            activeTab,
            bulkMapping,
            bulkMappingType,
            cancelMapping: this.cancelMapping,
            episodeOnly: this.isRecordShow(),
            error,
            fetched,
            fetching,
            formData,
            filterByEpisodes: this.shouldFilterByEpisode(),
            franchiseData: this.isRecordShow() ? get(mappingData, 'franchise', {}) : {},
            isTabActive,
            lastMassItem,
            mapItem: this.mapItem,
            mappingCancelMapping,
            mappingCompleteMapping,
            mappingCreateCustomShell,
            mappingData,
            mappingGoToNextMediaItem,
            mappingReset,
            mappingResetContentType,
            mappingSetBulkMapping,
            mappingSetData,
            mappingSetDataFromShell,
            mappingSetMassMapping,
            mappingSetShowMessage,
            mappingSetShowRememberMapping,
            mappingSkipMassMapping,
            massActionSetChildFormData,
            massActionSubmit,
            massActionData,
            massMapping,
            massShell,
            massShellActive,
            mediaItemData,
            mediaItemDetailFetching,
            mediaItems,
            mediaItemsFilter,
            rememberMappingData,
            response,
            routerParams,
            selectFirstTab,
            selectTab,
            setFieldValue,
            setFieldValues,
            shellContentType,
            showBulkMapping:
                bulkMapping &&
                (bulkMappingType === 'SPECIALS' || (bulkMappingType === 'SHOWS' && get(mappingData, 'franchise'))),
            showMessage,
            showRememberMapping,
            unmappedMediaItems,
            unmappedMediaItemsFilter,
            username,
            validShell,
        };

        return children(childrenProps);
    }
}

Mapping.propTypes = {
    activeTab: PropTypes.string,
    bulkMapping: PropTypes.bool,
    bulkMappingType: PropTypes.string,
    children: PropTypes.func,
    error: PropTypes.string,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    formData: PropTypes.object,
    lastMassItem: PropTypes.bool,
    mappingCancelMapping: PropTypes.func,
    mappingCompleteMapping: PropTypes.func.isRequired,
    mappingCreateCustomShell: PropTypes.func,
    mappingData: PropTypes.object,
    mappingGoToNextMediaItem: PropTypes.func.isRequired,
    mappingReset: PropTypes.func.isRequired,
    mappingResetContentType: PropTypes.func.isRequired,
    mappingSetBulkMapping: PropTypes.func.isRequired,
    mappingSetData: PropTypes.func.isRequired,
    mappingSetDataFromShell: PropTypes.func.isRequired,
    mappingSetMassMapping: PropTypes.func,
    mappingSetShowMessage: PropTypes.func.isRequired,
    mappingSetShowRememberMapping: PropTypes.func.isRequired,
    mappingSkipMassMapping: PropTypes.func.isRequired,
    massActionData: PropTypes.object,
    massActionSetChildFormData: PropTypes.func,
    massActionSubmit: PropTypes.func,
    massMapping: PropTypes.bool,
    massShell: PropTypes.bool,
    massShellActive: PropTypes.bool,
    mediaItemData: PropTypes.object,
    mediaItemDetailFetching: PropTypes.bool,
    mediaItems: PropTypes.array,
    mediaItemsFilter: PropTypes.array,
    rememberMappingData: PropTypes.object,
    resetOnUnmount: PropTypes.bool,
    response: PropTypes.array,
    routerParams: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
    setFieldValues: PropTypes.func.isRequired,
    shellContentType: PropTypes.string,
    showMessage: PropTypes.bool,
    showRememberMapping: PropTypes.bool,
    unmappedMediaItems: PropTypes.array,
    unmappedMediaItemsFilter: PropTypes.array,
    username: PropTypes.string,
    validShell: PropTypes.bool,
};

Mapping.contextType = TabContext;

const mapStateToProps = ({auth, formData, mapping, massActionData, servicesSearchData}) => ({
    formData,
    ...mapping,
    mediaItemDetailFetching: get(servicesSearchData, 'mediaItemDetail.fetching'),
    massActionData,
    username: auth.user,
});

const mapDispatchToProps = {
    mappingCancelMapping,
    mappingCompleteMapping,
    mappingCreateCustomShell,
    mappingGoToNextMediaItem,
    mappingReset,
    mappingResetContentType,
    mappingSetBulkMapping,
    mappingSetData,
    mappingSetDataFromShell,
    mappingSetMassMapping,
    mappingSetShowMessage,
    mappingSetShowRememberMapping,
    mappingSkipMassMapping,
    massActionSetChildFormData,
    massActionSubmit,
    setFieldValue,
    setFieldValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(Mapping);
